module.exports = __webpack_public_path__ + "img/9791187206774.4d09fdf3.jpg";